import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import { CreateDemoRequestBody } from '@inversor-hub/types';

export function useCreateDemoRequest() {
  return useMutation({
    mutationFn: async (body: CreateDemoRequestBody) => {
      await apiClient.post('/demo-requests', body);
    },
  });
}
